module.exports = __webpack_public_path__ + "static/img/wrightinTwo.94e65b8d.png";